import { clone } from '@/utils';
import * as assignment_config from './assignment';

/**
 * 获取分配表单配置
 * @param {string[]} keys 表单字段名称组成的数组
 * @returns {Object}
 */
export const getAssignmentConfig = (keys = []) => {
  const config = clone(assignment_config);
  for (const key in config) {
    if (config[key] && !(keys.includes(key))) {
      delete config[key];
    }
  }
  return config;
};
